import type { RequestClientAdminsBulkDeletion } from '@fukuri-admins/apis/client/gen/model';
import { format } from 'date-fns';
import type { UserBulkDeletionFormValues } from '../schema';

export const generateBulkDeletionRequest = (
  data: UserBulkDeletionFormValues
): RequestClientAdminsBulkDeletion => ({
  file: data.file,
  selected_option: data.registrationType,
  scheduled_date: data.scheduledDate ? format(data.scheduledDate, 'yyyy-MM-dd') : null,
  scheduled_hour: data.scheduledTime ?? null,
});
